/**
 * Миксин для submenu group
 */
export default {
    props: {
        currentPage: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            currentCleanUrl: null,
        };
    },
    created() {
        const url = new URL(window.location.href); // Получаем текущий URL
        this.currentCleanUrl = url.origin + url.pathname; // Получаем URL без GET-параметров и фрагмента
    },
    methods: {
        getLink(link) {
            return this.currentCleanUrl + link;
        },
    },
}
